import { useSlotLabel } from "../hooks/useSlotLabels";

export default function RestraintCountsHeadingSlot() {
  const lbl = useSlotLabel("restraint.counts-heading");
  return (
    <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-500 mt-2">
      {lbl("title", "Restraint counts")}
    </h4>
  );
}
